import { FieldConfig } from "./types";

export const salientFactsConfig: FieldConfig[][] = [
    [
        {
            label: "County",
            field: "county",
            placeholder: "Enter County",
        },
        {
            label: "Date of Value",
            field: "dateOfValue",
            type: "date",
        },
    ],
    [
        {
            label: "Taxes Payable Year",
            field: "taxesPayableYear",
            placeholder: "Enter Year",
        },
        {
            label: "Jurisdiction",
            field: "jurisdiction",
            placeholder: "Enter Jurisdiction",
        },
    ],
    [
        {
            label: "Property Type",
            field: "propertyType",
            placeholder: "Enter Property Type",
        },
        {
            label: "Number of Buildings",
            field: "numberOfBuildings",
            type: "number",
        },
    ],
    [
        {
            label: "Building Area (sqft)",
            field: "total",
            type: "number",
            unit: "sqft",
            nested: {
                parent: "buildingArea",
                field: "total",
            },
        },
        {
            label: "Year Built",
            field: "yearBuilt",
            type: "number",
        },
    ],
    [
        {
            label: "Site Area (sqft)",
            field: "sqFt",
            type: "number",
            unit: "sqft",
            nested: {
                parent: "siteArea",
                field: "sqFt",
            },
        },
        {
            label: "Buildable (sqft)",
            field: "buildable",
            type: "number",
        },
    ],
    [
        {
            label: "Parcel Number",
            field: "parcelNumber",
            placeholder: "Enter Parcel Number",
        },
        {
            label: "Reference Number",
            field: "referenceNumber",
            placeholder: "Enter Reference Number",
        },
    ],
];
